export default {
  containerStyle: {
    display: "flex",
    flexWrap: "wrap" as "wrap",
  },

  noResultsContainerStyle: {
    display: "flex",
    width: "50%",
    margin: "auto",
    padding: "5rem",
  },
};
